var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rubric-settings-tab"},[_c('div',{staticClass:"settings-content"},[_c('Settings',{attrs:{"title":_vm.$t('rubrics.settings'),"category":_vm.category,"grade":_vm.grade,"language":_vm.language,"intensity":_vm.intensity}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }